import { DateOnly, format } from '@if/core/date'
import { formatCurrency } from '@if/core/utils'
import { Chip, Skeleton, Stack, Typography } from '@mui/material'
import { EInteracWireStatus, InteracWire } from '@src/types/interac'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

interface InteracWireInformationProps {
  interacWire: InteracWire | null
}

const InteracWireInformation = ({ interacWire }: InteracWireInformationProps) => {
  const { t } = useTranslation()
  return (
    <Stack>
      {interacWire ? (
        <Stack direction="row" justifyContent="space-between" gap={1}>
          <span>{`${interacWire.sentBy} (${interacWire.senderEmail})`}</span>
          <span>{formatCurrency(interacWire.amount)}</span>
        </Stack>
      ) : (
        <Skeleton variant="rectangular" />
      )}
      <Typography variant="subtitle2" component="div">
        {interacWire ? (
          t('interacWire.receivedOn', { date: format(new DateOnly(interacWire.receivedOn), 'PPPP') })
        ) : (
          <Skeleton variant="text" width={200} />
        )}
      </Typography>
      <Typography variant="subtitle1" component="div">
        {t('interacWire.message')}:
      </Typography>
      <Typography variant="body2" component="div">
        {interacWire ? interacWire.message : <Skeleton variant="text" />}
      </Typography>
      {interacWire?.status == EInteracWireStatus.InProcess && <Chip color="warning" variant="outlined" label={t('interacWire.inprocess')} />}
    </Stack>
  )
}

export default memo(InteracWireInformation)
